// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { CartProvider } from './context/CartProvider';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import ProductDetailPage from './pages/ProductDetailPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ProtectedRoute from './components/protected-route/ProtectedRoute';
import CheckoutPage from './pages/CheckoutPage'
import SuccessPage from './pages/SuccessPage';
import { NotificationProvider } from './context/NotificationContext';
import Notification from './components/common/Notification';
import ResetPasswordPage from './pages/ResetPasswordPage';

import './App.css';
import UnsubscribedPage from './pages/UnsubscribedPage';
import AboutPage from './pages/AboutPage';
import Faq from './pages/Faq';

function App() {
  // All the image rotation logic has been removed.

  return (
    <NotificationProvider>
      <CartProvider>
        <Router>
          <Notification />
            <Routes>
              {/* We no longer pass the currentImage prop to HomePage */}
              <Route path='/' element={<HomePage />} />
              <Route path='/category/:category_slug' element={<CategoryPage />}/>
              <Route path='/:category_slug' element={<CategoryPage />} />
              <Route path='/:category_slug/:product_slug' element={<ProductDetailPage />} />
              <Route path='/login' element={<LoginPage />} />
              <Route path='/register' element={<SignupPage />} />
              <Route
                path='/checkout'
                element={
                  <ProtectedRoute>
                    <CheckoutPage />
                  </ProtectedRoute>
                }
              />
              <Route path='/success' element={<SuccessPage />} />
              <Route path='/unsubscribed' element={<UnsubscribedPage />} />
              <Route path='/about' element={<AboutPage />} />
              <Route path='/faq' element={<Faq />} />
              <Route path='/reset-password' element={<ResetPasswordPage />} />
          </Routes>
        </Router>
      </CartProvider>
    </NotificationProvider>
  );
}

export default App;
